module.exports = __webpack_public_path__ + "static/media/upload-autosign.7ff424bc.svg";